"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const id_1 = __importDefault(require("date-fns/locale/id")); //
const dateIdID = {
    name: 'id-ID',
    locale: id_1.default
};
exports.default = dateIdID;
